import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FIELD_REQUESTS_WITH_DISABLED_BUTTONS_WHILE_SUBMITTING } from "@krea/customer-features/utils";

import LoanApplicationFormNavigation from "../loan-application-form-navigation";

export const FieldRequestNavigator = ({
  className,
  menu,
  onGoToPreviousStep,
  onGoToNextStep,
  goToPreview,
  isCurrentFieldRequestSubmitted,
  isCurrentFieldRequestSubmitting,
  field,
}: {
  className?: string;
  menu?: unknown;
  onGoToPreviousStep?: () => void;
  onGoToNextStep?: () => void;
  goToPreview?: () => void;
  isCurrentFieldRequestSubmitted?: boolean;
  isCurrentFieldRequestSubmitting?: boolean;
  field: string;
}) => {
  const { t } = useTranslation();
  const [nextButtonText, setNextButtonText] = useState(
    t("iaq.skipQuestionCta"),
  );

  const isButtonDisabled = () => {
    return (
      FIELD_REQUESTS_WITH_DISABLED_BUTTONS_WHILE_SUBMITTING.includes(field) &&
      isCurrentFieldRequestSubmitting
    );
  };

  useEffect(() => {
    if (!isCurrentFieldRequestSubmitting) {
      if (isCurrentFieldRequestSubmitted) {
        setNextButtonText(t("iaq.nextQuestionCta"));
      } else {
        setNextButtonText(t("iaq.skipQuestionCta"));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCurrentFieldRequestSubmitted, isCurrentFieldRequestSubmitting]);

  return (
    <>
      <div className={className}>
        <LoanApplicationFormNavigation
          customButtonText={nextButtonText}
          nextButtonVariant={
            isCurrentFieldRequestSubmitted ? "contained" : "outlined"
          }
          goToNextStep={
            goToPreview
              ? goToPreview
              : onGoToNextStep
                ? onGoToNextStep
                : undefined
          }
          goToPreviousStep={onGoToPreviousStep && onGoToPreviousStep}
          disabledNavigationBeforeFormCompletion={isButtonDisabled()}
        />
      </div>
    </>
  );
};
